import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import MatterStage from '../../entities/matterStage';
export function deleteMatterStage(matterStage: MatterStage, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = matterStage.id;}
const _work = workingSet();




matterStage.status = 'D';
matterStage.addedOn = newHRTimestamp();
matterStage.addedBy = getCurrentUserId();
matterStage.importSource = targetImportSource;
matterStage.importId = mergeId;
store.dispatch(Actions.MatterStageActions.removeMatterStageQueue(matterStage));
}


